import React from "react"

export const ArticleContentComponentContainer = ({
  children,
  custom_classes = "",
  attributes,
}) => {
  return (
    <div
      {...attributes}
      className={`columns is-mobile is-centered ${custom_classes}`}
    >
      <div className="column is-9-desktop is-12-touch">{children}</div>
    </div>
  )
}
